import invitation from './invitation';
import payslips from './payslips';

let messages = Object.assign({}, invitation, payslips);

export default messages;
